<template>
    <Wrapper :title="$t('revoke.accountRevoke')" @on-back="$emit('on-back', $options.name)">
        <template #content>
            <h2 class="text-base mb-24">{{ $t('revoke.protocol') }}</h2>
            <p>{{ $t('common.hello') }}</p>
            <br />
            <p class="indent-2">{{ $t('revoke.protocolDetail0') }}</p>
            <p class="indent-2">{{ $t('revoke.protocolDetail1') }}</p>
            <p class="indent-2">{{ $t('revoke.protocolDetail2') }}</p>
            <p class="indent-2">{{ $t('revoke.protocolDetail3') }}</p>
            <br />
            <p class="indent-2">{{ $t('revoke.protocolDetail4') }}</p>
        </template>
        <template #footer>
            <div class="agreed flex text-xs text-left mb-12">
                <van-checkbox v-model="agreed" shape="square" icon-size="12" />
                <i18n path="revoke.protocolAgreed" tag="div">
                    <a place="protocol" @click="openProtocol($t('revoke.protocol'))">
                        {{ $t('revoke.protocol') }}
                    </a>
                </i18n>
            </div>
            <van-button type="info" class="w-full" @click="handleClick">
                {{ $t('common.nextStep') }}
            </van-button>
        </template>
    </Wrapper>
</template>

<script>
import Vue from 'vue';
import { Button, Dialog } from 'vant';
import { Platform } from '@/enums';
import Wrapper from './Wrapper.vue';
import { Target } from '../constant';

Vue.use(Button);
Vue.use(Dialog);

export default {
    name: 'RevokeProtocol',
    components: {
        Wrapper,
    },
    props: {
        initialRevoke: {
            type: Object,
            required: true,
        },
        platform: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            agreed: false,
        };
    },
    methods: {
        handleClick() {
            if (!this.agreed) {
                return Dialog.alert({
                    title: this.$t('common.tip'),
                    message: this.$t('revoke.confirmTip'),
                    confirmButtonText: this.$t('common.confirm'),
                    confirmButtonColor: 'var(--g-text-link-color)',
                    getContainer: '#index',
                });
            }

            this.$emit('on-step', { current: Target.RevokeProtocol, target: Target.Reconfirm });
        },
        openProtocol(title = '') {
            if ([Platform.WebView, Platform.Android].includes(this.platform)) {
                this.$router.push({
                    name: 'Protocol',
                    query: {
                        src: this.initialRevoke.acctDeletionAgreementUrl,
                        name: title,
                        showNavbar: true,
                        location: JSON.stringify({
                            name: 'Revoke',
                            query: { target: Target.RevokeProtocol },
                        }),
                    },
                });
            } else {
                window.open(this.initialRevoke.acctDeletionAgreementUrl, '_blank');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.agreed {
    color: var(--g-gray-4);

    .van-checkbox {
        min-width: 15px;
        margin-right: 5px;
    }
}
</style>
